const RIG_TYPES = {
  PERMANENT: 'permanent',
  EPHEMERAL: 'ephemeral',
  DEVICE: 'device',
};

export default RIG_TYPES;
